import { fromNow } from '@btime/helpers'
import { useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { RefetchingIndicator } from '../../../../components/helpers/StatePresenter'
import { checklistsClient } from '../../../../utils/apollo/api'
import { useChecklistsState } from '../_load/ChecklistsLoader'
import { useGetAllChecklists } from '../../../../containers/checklists/SelectAllChecklistsLink'
import { useOpenChecklistModal } from '../../../../utils/routes/modals/modalsActions'
import { useRowActionsColumn } from '../../../../components/tables/Table'
import DataTable from '../../../../packages/kiti/components/table/DataTable'
import ListCounter from '../../../../components/helpers/ListCounter'
import SwitchDisabled from '../../../../components/helpers/disabled/SwitchDisabled'
import UsagesTags from '../../../../containers/checklists/UsagesTags'
import { useChecklistActionsList } from '../../../../utils/actions/checklist/list'
import Text from '../../../../packages/kiti/components/presentation/Text'

const ChecklistsTable = () => {
  const { t } = useTranslation('listChecklists')
  const canEdit = useSessionPermission('editChecklist')
  const { checklists: data } = useChecklistsState()
  const openDetailsModal = useOpenChecklistModal()
  const onSelectAll = useGetAllChecklists()

  const columns = [
    {
      label: t('name'),
      headerSideContent: (
        <>
          <ListCounter
            client={checklistsClient}
            entity="checklists"
            filterName="ChecklistFilter"
            filters={{ includeDisabled: true }}
          />
          <RefetchingIndicator />
        </>
      ),
      dataIndex: 'name',
      sortIndex: 'NAME',
      flex: 4,
      onClick: (value, record) => openDetailsModal(record),
      bold: true
    },

    {
      label: t('availableIn'),
      dataIndex: 'usages',
      sortIndex: false,
      render: (value, record) => <UsagesTags value={value} />,
      flex: 3
    },

    {
      label: t('type'),
      dataIndex: ['type', 'name'],
      sortIndex: 'TYPE_NAME',
      render: (value) => <Text>{t('common:' + value)}</Text>,
      flex: 2
    },

    {
      label: t('updatedAt'),
      dataIndex: 'updatedAt',
      sortIndex: 'UPDATED_AT',
      format: fromNow,
      flex: 2
    },

    {
      label: t('enabled'),
      dataIndex: 'enabled',
      sortIndex: 'ENABLED',
      flex: 1,
      render: (_, record) => (
        <SwitchDisabled
          client={checklistsClient}
          entity="Checklist"
          record={record}
          size={'small'}
          disabled={!canEdit}
        />
      )
    },

    {
      label: t('actions'),
      flex: 1,
      render: useRowActionsColumn(useChecklistActionsList)
    }
  ]

  return <DataTable rowKey="id" columns={columns} data={data} inPanel size="medium" onSelectAll={onSelectAll} />
}

export default ChecklistsTable
